module.exports = __webpack_public_path__ + "img/dataAssetName.68174670.png";